export default "__VITE_ASSET__DqCJPZf$__"